// shared/directives/if-node.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IfNodeHideDirective } from './if-node-hide.directive';
import { IfNodeShowDirective } from './if-node-show.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [IfNodeHideDirective, IfNodeShowDirective],
  exports: [IfNodeHideDirective, IfNodeShowDirective],
})
export class IfNodeModule {}
